import { CINEMARK_TICKETS_VENDOR } from "@multicines/utils";
import React from "react";

import Styles from "./SessionType.styles";
import { SessionTypeProps as Props } from "./SessionType.types";
import Divider from "../Divider/Divider";
import TheaterTypeList from "../TheaterTypeList/TheaterTypeList";
import { useStoresStore } from "stores/stores/stores.store";

const SessionType: React.FC<Props> = props => {
  const { className, sessionType, position, onClick } = props;
  const { sessionTypeCount, disabled, isPremiere } = props;
  const selectedStore = useStoresStore(store => store.selectedStore);

  const { name, theaterTypes } = sessionType;

  const [ticketsStore] = selectedStore ?? [];
  const { vendor } = ticketsStore ?? {};
  const { id: vendorId } = vendor ?? {};

  return (
    <Styles className={`SessionType ${className}`} isPremiere={isPremiere}>
      {name ? (
        <>
          {/* TODO: Remove vendor validation when cinemark sync is done */}
          {typeof vendorId !== "undefined" &&
          vendorId !== CINEMARK_TICKETS_VENDOR.id ? (
            <>
              <p className="SessionType__name" translate="no">
                {name}
              </p>
              <div className="SessionType__divider" />
            </>
          ) : null}
          <TheaterTypeList
            className="SessionType__theater-type"
            theaters={theaterTypes}
            disabled={disabled}
            name={name}
            isPremiere={isPremiere}
            onClick={onClick}
          />
          {position !== sessionTypeCount - 1 ? (
            <Divider className="SessionType__separator" />
          ) : null}
        </>
      ) : null}
    </Styles>
  );
};

export default SessionType;
